import React from 'react';
import CompanyTitle from './CompanyTitle.jsx';
import ContentBackButton from './ContentBackButton.jsx';

const breadcrumbMap = (history) => ({
  alertSettings: {
    url: () => '/blueprint/settings/alerts',
    text: () => 'Alert Settings',
  },
  home: {
    url: () => '/blueprint',
    text: () => CompanyTitle,
  },
  contentView: {
    url: () => '',
    text: () => <ContentBackButton history={history} />,
  },
  library: {
    url: () => '/blueprint/library',
    text: () => 'Library',
  },
  competitorContentFeed: {
    url: () => '/blueprint/library/competitors',
    text: () => 'Competitors Library',
  },
  savedContentFeed: {
    url: () => '/blueprint/library/saved',
    text: () => 'Saved Library',
  },
  subscribedContentFeed: {
    url: () => '/blueprint/library/subscribed',
    text: () => 'Subscribed Library',
  },
  searchFeed: {
    url: () => '/blueprint/search',
    text: () => 'Search Results',
  },
  partnershipEntity: {
    url: (state) => `/blueprint/${state.partnershipView.metadata.data.type}/${state.partnershipView.metadata.data.public_id}`,
    text: (state) => state.partnershipView.metadata.data.name,
  },
  partnershipView: {
    url: (state) => `/blueprint/${state.partnershipView.metadata.data.type}/${state.partnershipView.metadata.data.public_id}/` +
    `${state.partnershipView.partner.data.type}/${state.partnershipView.partner.data.public_id}`,
    text: (state) => state.partnershipView.partner.data.name,
  },
  brandView: {
    url: (state) => `/blueprint/brand/${state.brandView.data.public_id}`,
    text: (state) => state.brandView.data.name,
  },
  brandPaidContentFeed: {
    url: (state) => `/blueprint/brand/${state.brandView.data.public_id}/paid`,
    text: () => 'Paid Content',
  },
  brandOwnedContentFeed: {
    url: (state) => `/blueprint/brand/${state.brandView.data.public_id}/owned`,
    text: () => 'Owned Content',
  },
  brandInsightsView: {
    url: (state) => `/blueprint/brand/${state.brandView.data.public_id}/analytics`,
    text: () => 'Analytics',
  },
  publisherView: {
    url: (state) => `/blueprint/publisher/${state.publisherView.data.public_id}`,
    text: (state) => state.publisherView.data.name,
  },
  publisherPaidContentFeed: {
    url: (state) => `/blueprint/publisher/${state.publisherView.data.public_id}/paid`,
    text: () => 'Paid Content',
  },
  publisherInsightsView: {
    url: (state) => `/blueprint/publisher/${state.publisherView.data.public_id}/analytics`,
    text: () => 'Analytics',
  },
  settings: {
    url: () => '/blueprint/settings',
    text: () => 'Settings',
  },
  settingsProfileView: {
    url: () => '/blueprint/settings/profile',
    text: () => 'Profile',
  },
  settingsCompetitorsView: {
    url: () => '/blueprint/settings/competitors',
    text: () => 'Competitors',
  },
});

export default breadcrumbMap;
